import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Selector, Button, Modal, Toast, Image } from 'antd-mobile';
import { addClassNameById, removeClassNameById } from "../../../utils/dom";
import PriceRule from "../../PriceRule";
import HomeSwiper from "../../Home/HomeSwiper";
import api from "../../../api";
import "./style.less";

const newPriceOptions = [
  {
    label: '1元',
    value: 100
  },
  {
    label: '2元',
    value: 200
  },
  {
    label: '3元',
    value: 300
  },
  {
    label: '5元',
    value: 500
  },
]

const CreateOrder = (props) => {
  const { aliOrWx, qrcode, qrcodets, handleInvalidQrcode } = props

  const navigate = useNavigate()
  const [device, setDevice] = useState()
  const [selected, setSelected] = useState()
  const [duration, setDuration] = useState('0')
  const [priceCost, setPriceCost] = useState(0)
  const [priceList, setPriceList] = useState([])
  const [priceOptions, setPriceOptions] = useState([])
  const [priceError, setPriceError] = useState('')

  const headImage = 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_head.png'

  // 获取设备信息
  const refreshDeviceInfo = () => {
    api.deviceQueryByQrcode({ qrcode }).then((res) => {
      const deviceData = res.data?.data;
      if (!deviceData) {
        Toast.show({ content: '无效的二维码' })
        handleInvalidQrcode()
        return
      }

      setDevice(deviceData)
    })
  }

  // 获取价格列表
  const refreshDevicePriceList = (device) => {
    const cmd = {
      deviceId: device.id,
      priceId: device.priceId
    }
    api.deviceQueryOrderPrice(cmd).then((res) => {
      const priceData = res.data;

      if (priceData?.data?.length > 0) {
        const options = priceData.data.map((element, index) => {
          return { label: '' + element.time + '小时', value: element.time }
        })
        setPriceOptions(options)
        setPriceList(priceData.data)
      } else {
        setPriceError('获取充电时长和价格异常，请重试或联系管理员')
        return
      }
    })
  }

  // 展示计费规则弹窗
  const handlePriceRuleClick = () => {
    Modal.alert({
      content: <PriceRule price={device.price} />
    })
  }

  // 处理选择金额右侧 充值 按钮点击事件
  const handleChargeClick = () => {
    navigate('/wallet/1')
  }

  // 处理选择充电口点击事件
  const handleDevicePortClick = (port) => {
    if (!port || !device || device.status === 2 || device.online === 2) {
      return
    }

    if (port.status === 2 || port.inUse === 1) {
      return
    }

    if (selected?.id === port.id) {
      return
    }

    setSelected(port)

    if (selected?.id > 0) {
      removeClassNameById(selected.id, 'active')
    }
    addClassNameById(port.id, 'active')
  }

  // 处理充电时长点击事件
  const handleChargeTimeClick = (time) => {
    setDuration(time)

    priceList.forEach(price => {
      if (price.time === time) {
        setPriceCost(price.cost)
      }
    })
  }

  // 处理下单按钮点击事件
  const handleCreateOrderClick = () => {
    if (!selected || priceCost === 0) {
      return
    }

    const cmd = {
      source: 1,
      costType: 1,
      startMode: 2,
      payChannel: 0,
      chargeTime: 15,  // 固定15小时
      payFee: priceCost,
      deviceId: device.id,
      portId: selected.id,
      priceId: device.priceId,
    }

    api.orderCreate(cmd).then((res) => {
      const data = res.data;
      if (!data) {
        Toast.show({ content: '订单创建失败，请稍后重试' })
        return
      }
      if (data.code !== 0) {
        Toast.show({ content: data.message })
        return
      }

      // 跳转到收银台
      const orderId = data.data.orderId;
      navigate('/order/' + orderId + '/pay')
    })
  }

  // 触发刷新页面
  useEffect(() => {
    if (qrcode) {
      refreshDeviceInfo()
    }
  }, [qrcodets])


  // 页面布局
  if (!device) {
    return (<div></div>)
  }

  return (
    <div className="create-order-wrapper">
      {/* 设备信息 */}
      {/*
      <h3>设备信息</h3>
      <ul className="device-info">
        <li>
          <span>设备编号：</span>
          <span>{device?.no}</span>
        </li>
        <li>
          <span>设备状态：</span>
          <span>{device?.status === 1 ? '正常' : '故障'}</span>
        </li>
        <li>
          <span>是否在线：</span>
          <span>{device?.online === 1 ? '在线' : '离线'}</span>
        </li>
      </ul>
       */}

      {/* 只有微信环境展示广告 --> 去除广告 */}
      <Image src={headImage} />

      {/* 选择端口 */}
      <div className="item-head">
        <div className="item-head-left">编号：{device?.no}</div>
        <div className="item-head-right">{device?.online === 1 ? '在线' : '离线'}</div>
      </div>

      <div className="port-list-wrapper">
        <div className="port-list">
          {
            device?.ports?.map((element, index) => {
              const deviceCanUse = device?.online === 1 && device?.status === 1;

              // 端口状态  1:正常 2:故障
              const status = element.status
              // 端口是否使用  1:使用中 2:空闲
              const inUse = element.inUse

              let statusClass = ''
              let statusText = ''

              if (!deviceCanUse) {
                statusClass = 'error'
                statusText = '不可用'
              } else if (status === 2) {
                statusClass = 'error'
                statusText = '故障'
              } else if (inUse === 1) {
                statusClass = 'inuse'
                statusText = '充电中'
              } else if (inUse === 2) {
                statusClass = 'notinuse'
                statusText = '空闲'
              }

              return (
                <div className="port-item-wrapper" key={index}>
                  <div className="port-item" id={element.id} onClick={() => handleDevicePortClick(element)}>
                    <div className="portno"><span>{element.portNo}号口</span></div>
                    <div className={"portstatus " + statusClass}><span>{statusText}</span> </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>

      {/* 选择充电金额 */}
      {/* <h3>选择充电金额</h3> */}
      <div className="item-head">
        <div className="item-head-left">选择充电金额</div>
        <div className="item-head-right">
          <Button color='danger' size="small" fill='none' onClick={() => handleChargeClick()}>
            充值优惠
          </Button>
        </div>
      </div>

      {
        priceError ?
          <div className="time-select-error">
            {priceError}
          </div>
          :
          <div className="time-select-wrapper">
            <div className="time-select-price">
              将预付 <span className="price-number">{priceCost / 100}</span> 元
              <Button color='warning' fill='none' size="mini" onClick={handlePriceRuleClick}>
                点击查看计费规则
              </Button>
            </div>

            <Selector
              style={{
                '--border-radius': '5px'
              }}
              columns={4}
              options={newPriceOptions}
              onChange={v => {
                if (v.length) {
                  setPriceCost(v[0])
                }
              }}
            />
          </div>
      }

      <div className="create-order-button">
        <Button block color='success' size='large' onClick={handleCreateOrderClick}>
          下 单
        </Button>
      </div>
    </div>
  )
}

export default CreateOrder;